import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import "./HospitalCommonPopup.css";
import "./HospitalModifyPopup.css";
import InputContainer from "../../../../components/Util/InputContainer";
import TimePicker from "../../../../components/Util/TimePicker";
import { formatPhoneNumber } from "../../../../utils/formatPhoneNumber";
import Editor from "../../../../components/Dashboard/Editor";
import Swal from "sweetalert2";

function HospitalModify({ isOpen, onClose, onSave, selectedRow, onDelete }) {
  const initialHospitalData = {
    id: "",
    hospitalId: "",
    hospitalName: "",
    hospitalAddress: "",
    hospitalTelNo: "",
    hospitalInfo: "",
    weekdayStartTime: "",
    weekdayEndTime: "",
    nightStartTime: "",
    nightEndTime: "",
    satStartTime: "",
    satEndTime: "",
    lunchStartTime: "",
    lunchEndTime: "",
    restDt: "",
  };
  const [hospitalData, setHospitalData] = useState({ ...initialHospitalData });

  // 에디터 ref 선언
  const editorRef = useRef(null);

  // 입력값이 변경될 때마다 상태 업데이트
  const hospitalOnChange = (e) => {
    const { name, value } = e.target;

    // 전화번호 입력인 경우 포맷팅 적용
    if (name === "hospitalTelNo") {
      setHospitalData({
        ...hospitalData,
        [name]: formatPhoneNumber(value),
      });
    } else {
      setHospitalData({
        ...hospitalData,
        [name]: value,
      });
    }
  };

  useEffect(() => {
    // 팝업이 열릴 때마다 선택된 데이터로 초기화
    if (isOpen) {
      setHospitalData({
        id: selectedRow ? selectedRow.id : "",
        hospitalId: selectedRow ? selectedRow.hospitalId : "",
        hospitalName: selectedRow ? selectedRow.hospitalName : "",
        hospitalAddress: selectedRow ? selectedRow.hospitalAddress : "",
        hospitalTelNo: selectedRow ? selectedRow.hospitalTelNo : "",
        hospitalInfo: selectedRow ? selectedRow.hospitalInfo : "",
        weekdayStartTime: selectedRow ? selectedRow.weekdayStartTime : "",
        weekdayEndTime: selectedRow ? selectedRow.weekdayEndTime : "",
        nightStartTime: selectedRow ? selectedRow.nightStartTime : "",
        nightEndTime: selectedRow ? selectedRow.nightEndTime : "",
        satStartTime: selectedRow ? selectedRow.satStartTime : "",
        satEndTime: selectedRow ? selectedRow.satEndTime : "",
        lunchStartTime: selectedRow ? selectedRow.lunchStartTime : "",
        lunchEndTime: selectedRow ? selectedRow.lunchEndTime : "",
        restDt: selectedRow ? selectedRow.restDt : "",
      });
    }
  }, [isOpen, selectedRow]);

  // 수정 버튼 클릭 시 호출되는 함수
  const hospitalModifyClick = () => {
    // 저장 시점에 현재 에디터 내용을 가져와서 저장
    let updatedData = { ...hospitalData };

    if (editorRef.current) {
      const html = editorRef.current.getHTML();
      updatedData.hospitalInfo = html;
    }

    if (updatedData.hospitalInfo === "" || updatedData.hospitalInfo === "<p><br></p>") {
      showWarningAlert("내용 입력해 주세요.");
      return;
    }

    updatedData.id = selectedRow.id;
    updatedData.links = selectedRow.links;
    onSave(updatedData);
  };

  const showWarningAlert = (text) => {
    Swal.fire({
      icon: "warning",
      title: "알림",
      text: text,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };
  const handleStartTimeChange = (startTimeInfo) => {
    if (startTimeInfo.startLabels === "평  일") {
      hospitalData.weekdayStartTime = `${startTimeInfo.startTime}시`;
    } else if (startTimeInfo.startLabels === "토요일") {
      hospitalData.satStartTime = `${startTimeInfo.startTime}시`;
    } else if (startTimeInfo.startLabels === "야간진료") {
      hospitalData.nightStartTime = `${startTimeInfo.startTime}시`;
    } else if (startTimeInfo.startLabels === "점심시간") {
      hospitalData.lunchStartTime = `${startTimeInfo.startTime}시`;
    }
  };

  const handleEndTimeChange = (endTimeInfo) => {
    if (endTimeInfo.endLabels === "평  일") {
      hospitalData.weekdayEndTime = `${endTimeInfo.endTime}시`;
    } else if (endTimeInfo.endLabels === "토요일") {
      hospitalData.satEndTime = `${endTimeInfo.endTime}시`;
    } else if (endTimeInfo.endLabels === "야간진료") {
      hospitalData.nightEndTime = `${endTimeInfo.endTime}시`;
    } else if (endTimeInfo.endLabels === "점심시간") {
      hospitalData.lunchEndTime = `${endTimeInfo.endTime}시`;
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Hospital Popup"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        },
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          border: "1px solid #ccc",
          background: "white",
          borderRadius: "4px",
          width: "970px",
          height: "620px",
        },
      }}
    >
      <div className="modal-header-close-button" onClick={onClose}>
        x
      </div>
      <div className="hospital-detail-modal-header">
        <h2>병원 상세정보</h2>
      </div>
      <div className="hospital-detail-body">
        <div style={{ display: "flex", flexDirection: "column", marginRight: "10px", paddingLeft: "7px" }}>
          <div className="input-container left-input-container">
            <div className="input-row" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <label htmlFor="hospitalId">병원 ID</label>
              <input type="text" name="hid" value={hospitalData.hospitalId} onChange={hospitalOnChange} placeholder="병원 ID" readOnly style={{ backgroundColor: "#eee" }} />
            </div>
          </div>
          <InputContainer label="병원명" name="hospitalName" value={hospitalData.hospitalName} onChange={hospitalOnChange} />
          <InputContainer label="병원 주소" name="hospitalAddress" value={hospitalData.hospitalAddress} onChange={hospitalOnChange} />
          <InputContainer label="병원 전화번호" name="hospitalTelNo" value={hospitalData.hospitalTelNo} onChange={hospitalOnChange} />
          <div className="input-container left-input-container">
            <div className="input-row" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", fontWeight: "400" }}>
              <label className="hospital-time-head" htmlFor="hospitalId">
                병원 시간
              </label>
              <div className="hospital-table-header">
                <div className="hospital-gubun">구분</div>
                <div className="hospital-content">내용</div>
              </div>
              <TimePicker
                labels={"평  일"}
                startTime={hospitalData.weekdayStartTime && hospitalData.weekdayStartTime.replace("시", "")}
                endTime={hospitalData.weekdayEndTime && hospitalData.weekdayEndTime.replace("시", "")}
                onStartTimeChange={handleStartTimeChange}
                onEndTimeChange={handleEndTimeChange}
              />
              <TimePicker
                labels={"토요일"}
                startTime={hospitalData.satStartTime && hospitalData.satStartTime.replace("시", "")}
                endTime={hospitalData.satEndTime && hospitalData.satEndTime.replace("시", "")}
                onStartTimeChange={handleStartTimeChange}
                onEndTimeChange={handleEndTimeChange}
              />
              <TimePicker
                labels={"야간진료"}
                startTime={hospitalData.nightStartTime && hospitalData.nightStartTime.replace("시", "")}
                endTime={hospitalData.nightEndTime && hospitalData.nightEndTime.replace("시", "")}
                onStartTimeChange={handleStartTimeChange}
                onEndTimeChange={handleEndTimeChange}
              />
              <TimePicker
                labels={"점심시간"}
                startTime={hospitalData.lunchStartTime && hospitalData.lunchStartTime.replace("시", "")}
                endTime={hospitalData.lunchEndTime && hospitalData.lunchEndTime.replace("시", "")}
                onStartTimeChange={handleStartTimeChange}
                onEndTimeChange={handleEndTimeChange}
              />
              <div className="rest-time-container">
                <div className="hospital-time">휴 진</div>
                <div className="hospital-time-info">
                  <input type="text" name="restDt" value={hospitalData.restDt} onChange={hospitalOnChange} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="right-input-container">
          <div className="input-container">
            <div className="input-row" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <label htmlFor="hospitalInfo" style={{ marginBottom: "5px" }}>
                병원 소개
              </label>
              <div className="hospital-editor-container">
                <Editor ref={editorRef} readOnly={false} initialHTML={hospitalData.hospitalInfo} placeholder="병원 소개를 입력하세요." />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hospital-detail-button-container">
        <button className="dashboard-content-button yellow-button popup-button" onClick={hospitalModifyClick}>
          수정
        </button>
        <button className="dashboard-content-button red-button popup-button" onClick={onDelete}>
          삭제
        </button>
        <button className="dashboard-content-button popup-button" onClick={onClose}>
          닫기
        </button>
      </div>
    </Modal>
  );
}

export default HospitalModify;
